import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

/** Excludes requests generated automatically (polls, startup hydration, refresh) from session activity. */
export const SKIP_SESSION_ACTIVITY = new HttpContextToken<boolean>(() => false);